import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { ScreenSize, WindowService } from '../../_service/screen-size.service';
import { environment } from '../../../environments/environment';
import { Utility } from 'app/_service/utility';
import { StorageService } from 'app/storageprovider';
import { AppStore } from '../../app.store';
import { Store } from 'redux';
import { ConfigState } from 'app/_model/config/config.reducer';
import { FooterService } from '../../_service/footer/footer.service';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {
  // screenType = ScreenSize;
  // screenSize;
  isAdult = environment.cinema === 2;
  environment = environment;
  host = this._utility.GetHost();
  isDark = false;

  subscript = null;
  partnerList = [];
  lastRegion = '';
  constructor(
    // private _windowService: WindowService,
    private _storage: StorageService,
    private _utility: Utility,
    @Inject(AppStore) private store: Store<ConfigState>,
    private _service:FooterService
  ) {
    // this._windowService.size$.subscribe((value: any) => {
    //   this.screenSize = value;
    // });
  }
  enableContact = this._utility.getSiteConfig.enableContact;
  isApp = environment.app;
  ngOnInit() {
    this._utility.GetOrCreateSubscript("theme.change").subscribe((theme) => {
      // console.log(theme);
      if (theme == "dark") {
        this.isDark = true;
      }
      else {
        this.isDark = false;
      }

    });
    this.isDark = !!parseInt(this._storage.GetConfig()["isDark"]|| "1");

    const region = this._storage.GetConfig()['region'];
    // console.log(region);
    // init
    this.getPartnerList(region);
    // after change region
    this.subscript = this.store.subscribe(() => {
      const region = this._storage.GetConfig()['region'];
      if (this.lastRegion !== region) {
        this.getPartnerList(region);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscript();
  }

  getPartnerList(region) {
    this.lastRegion = region;
    this._service.getCoBusiness(region).subscribe((r: any) => {
      // console.log(r);
      if (r.list) {
        this.partnerList = r.list;
      } else {
        this.partnerList = [];
      }
    });
  }


}
